import LocalStorageFunc from "../../helpers/localStorageFunc";
import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";

export default {
  namespaced: true,
  state: {
    paymentOffers: [],
    paymentSelectedOfferIndex: -1,
    appliedOfferDetails: {},
    selectedPaymentOfferTnc: {},
    tncModalFlag: false,
  },
  getters: {},
  mutations: {
    updatePaymentOffer(state, payload) {
      state.paymentOffers = payload;
    },
    updateSelectedPaymentOfferIndex(state, payload) {
      state.paymentSelectedOfferIndex = payload;
    },
    updatePmOfferDetails(state, payload) {
      state.appliedOfferDetails = payload;
      LocalStorageFunc.updatePaymentOfferpaymentId(state.appliedOfferDetails);
    },
    updateSelectedPaymentOfferTnc(state, payload) {
      state.selectedPaymentOfferTnc = payload;
    },
    updateTncModalFlag(state, payload) {
      state.tncModalFlag = payload;
    },
  },
  actions: {
    // paymentOfferTncApi({ commit }, payload) {
    //   ApiCalls.PAYMENT_OFFER_TNC_API({
    //     headers: Headers(),
    //     payload: {
    //       offerId: payload.offerId,
    //       langId: payload.langId,
    //       platform: payload.platform,
    //     },
    //   })
    //     .then(function (response) {
    //       if (response?.data?.tnc) {
    //         commit("updateSelectedPaymentOfferTnc", response.data);
    //       } else {
    //         commit("updateSelectedPaymentOfferTnc", []);
    //       }
    //     })
    //     .catch(function (error) {
    //       commit("updateSelectedPaymentOfferTnc", []);
    //     });
    // },
    // paymentOfferApi({ commit, state }) {
    //   ApiCalls.PAYMENT_OFFERS_API({
    //     headers: Headers(),
    //   })
    //     .then(function (response) {
    //       // response.data = StoreOfferApiResponse;
    //       if (response?.data?.paymentOffers?.data?.length > 0) {
    //         commit("updatePaymentOffer", response.data.paymentOffers.data);
    //         if (
    //           response.data.paymentOffers.data.length > 0 &&
    //           response.data.paymentOffers.data?.length !== undefined
    //         ) {
    //           if (LocalStorageFunc.getCouponCode()?.code !== undefined) {
    //             let currentCoupneCodeIndex =
    //               response.data.paymentOffers.data.findIndex(
    //                 (i) => i.promoCode == LocalStorageFunc.getCouponCode().code
    //               );
    //             commit(
    //               "updateSelectedPaymentOfferIndex",
    //               currentCoupneCodeIndex
    //             );
    //           }
    //           // commit("updateOfferApplyModalKey", true);
    //           // commit("updateOfferApplyResponse", { status: "SUCCESS" });
    //           LocalStorageFunc.setGetOfferSuccess("SUCCESS");
    //         }
    //       } else if (response?.data?.milestoneOffers?.data) {
    //         commit(
    //           "updatePaymentOffer",
    //           ...response.data.milestoneOffers.data.map((milestoneOffer) => {
    //             return { ...milestoneOffer, type: "MILESTONE" };
    //           })
    //         );
    //       }
    //     })
    //     .catch(function (error) {
    //       commit("updatePaymentOffer", {});
    //       commit("updateOfferApplyResponse", { status: "" });
    //       LocalStorageFunc.setGetOfferSuccess("");
    //     });
    // },
  },
};
